(function () {
  var STORAGE_KEY = 'vl_liked_products';
  var COUNTER_ENDPOINT = 'https://like-counter.t8g8s4rjwf.workers.dev/like';

  /* ── Toast notification ────────────────────────────────── */
  var toastEl = null;
  var toastTimer = null;

  function initToast() {
    if (toastEl) return;
    var style = document.createElement('style');
    style.textContent =
      '.vl-toast{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) scale(.95);' +
      'background:#3a2e35;color:#fff;padding:10px 20px;border-radius:999px;font-size:14px;' +
      'font-family:-apple-system,BlinkMacSystemFont,sans-serif;z-index:9999;pointer-events:none;' +
      'opacity:0;transition:opacity .25s ease,transform .25s ease;display:flex;align-items:center;gap:8px;' +
      'box-shadow:0 4px 16px rgba(0,0,0,.15)}' +
      '.vl-toast.is-visible{opacity:1;transform:translate(-50%,-50%) scale(1)}' +
      '.vl-toast svg{flex-shrink:0}' +
      '@media(prefers-reduced-motion:reduce){.vl-toast{transition:none}}';
    document.head.appendChild(style);
    toastEl = document.createElement('div');
    toastEl.className = 'vl-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
  }

  function showToast(message, liked) {
    initToast();
    clearTimeout(toastTimer);
    toastEl.classList.remove('is-visible');
    var heart = liked
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="#b8356f" stroke="#b8356f" stroke-width="1.75"><path d="M12 20.9c-.24 0-.47-.07-.67-.22C8.9 18.87 2.5 13.98 2.5 8.98 2.5 5.7 5.1 3 8.3 3c1.6 0 3.14.75 4.2 2.02C13.56 3.75 15.1 3 16.7 3c3.2 0 5.8 2.7 5.8 5.98 0 5-6.4 9.89-8.83 11.7-.2.15-.43.22-.67.22z"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.75"><path d="M12 20.9c-.24 0-.47-.07-.67-.22C8.9 18.87 2.5 13.98 2.5 8.98 2.5 5.7 5.1 3 8.3 3c1.6 0 3.14.75 4.2 2.02C13.56 3.75 15.1 3 16.7 3c3.2 0 5.8 2.7 5.8 5.98 0 5-6.4 9.89-8.83 11.7-.2.15-.43.22-.67.22z"/></svg>';
    toastEl.innerHTML = heart + '<span>' + message + '</span>';
    // Force reflow so the transition replays even if called in quick succession
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2000);
  }

  function readLiked() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeLiked(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('like:updated', { detail: { handles: handles } }));
  }

  function reportToCounter(productId, action) {
    if (!productId) return;
    fetch(COUNTER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: productId, action: action }),
    }).catch(function () {});
  }

  class VLLikeButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      this.productId = this.dataset.productId;
      this.toggleButton = this.querySelector('.like-button__toggle');
      if (!this.handle || !this.toggleButton) return;
      this._onUpdate = this.render.bind(this);
      this.toggleButton.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('like:updated', this._onUpdate);
      this.render();
    }
    disconnectedCallback() {
      document.removeEventListener('like:updated', this._onUpdate);
    }
    handleClick(event) {
      event.preventDefault();
      var liked = readLiked();
      var index = liked.indexOf(this.handle);
      var nowLiked = index === -1;
      if (nowLiked) { liked.push(this.handle); } else { liked.splice(index, 1); }
      writeLiked(liked);
      reportToCounter(this.productId, nowLiked ? 'like' : 'unlike');
      showToast(
        nowLiked ? 'Saved' : 'Removed',
        nowLiked
      );
      this.classList.add('is-animating');
      window.setTimeout(() => this.classList.remove('is-animating'), 350);
      if (!nowLiked) {
        var card = this.closest('[data-wishlist-card]');
        if (card) {
          card.style.transition = 'opacity 0.2s ease';
          card.style.opacity = '0';
          window.setTimeout(() => {
            card.remove();
            document.dispatchEvent(new CustomEvent('like:card-removed'));
          }, 200);
        }
      }
    }
    render() {
      var isLiked = readLiked().indexOf(this.handle) !== -1;
      this.classList.toggle('is-liked', isLiked);
      this.toggleButton.setAttribute('aria-pressed', String(isLiked));
      var label = isLiked ? this.toggleButton.dataset.labelRemove : this.toggleButton.dataset.labelAdd;
      if (label) this.toggleButton.setAttribute('aria-label', label);
    }
  }

  class VLLikeCount extends HTMLElement {
    connectedCallback() {
      this._onUpdate = this.render.bind(this);
      document.addEventListener('like:updated', this._onUpdate);
      this.render();
    }
    disconnectedCallback() {
      document.removeEventListener('like:updated', this._onUpdate);
    }
    render() {
      var count = readLiked().length;
      this.textContent = String(count);
      this.hidden = count === 0;
    }
  }

  if (!customElements.get('like-button')) customElements.define('like-button', VLLikeButton);
  if (!customElements.get('like-count')) customElements.define('like-count', VLLikeCount);

  window.VioletEyesLikes = { readLiked: readLiked, writeLiked: writeLiked, STORAGE_KEY: STORAGE_KEY };
})();